const contactData = {
    'formUrl': '<the url you want the form to be POSTed to>',
    'reCAPTCHA': '<your reCAPTCHA website key>'
}

export default contactData